module.exports = __webpack_public_path__ + "img/bondi-radio.801944c3.png";